import React from 'react'
import { Button } from 'reactstrap'

export default function ItemSearchTypeSelector (props) {
  return (
    <div>
      <Button 
        name='searchType' 
        onClick={(e) => props.handleChange(e)} 
        value='name' 
        color={props.searchType === 'name' ? 'primary' : 'secondary'}
      >
        Name
      </Button>
      <Button 
        name='searchType' 
        onClick={(e) => props.handleChange(e)} 
        value='code' 
        color={props.searchType === 'code' ? 'primary' : 'secondary'}
      >
        Code
      </Button>
      <Button 
        name='searchType' 
        onClick={(e) => props.handleChange(e)} 
        value='question' 
        color={props.searchType === 'question' ? 'primary' : 'secondary'}
      >
        Question
      </Button>
      <Button 
        name='searchType' 
        onClick={(e) => props.handleChange(e)} 
        value='node' 
        color={props.searchType === 'node' ? 'primary' : 'secondary'}
      >
        Node
      </Button>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentsManage/ItemSearchTypeSelector.js